import { render } from "./BucketListForm.vue?vue&type=template&id=54ef77a6"
import script from "./BucketListForm.vue?vue&type=script&lang=js"
export * from "./BucketListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__